import styled from 'styled-components';

export const TableWrapper = styled.div`
  overflow: auto;
  max-height: ${({ maxHeight }) => maxHeight || 'auto'};
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 3px;
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
`;
export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;

  th,
  td {
    border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
    padding: 8px 12px;
    text-align: left;
    height: 25px;
    box-sizing: content-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 60px;
  }

  tbody tr {
    height: 25px;
  }

  th {
    background: #e5e5e5;
    color: ${({ theme }) => theme.themeColors.text};

    font-weight: inherit;
    position: sticky;
    top: 0;
    z-index: 2;
    user-select: none;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #d0d0d0;
    }
  }

  td.row-number {
    background: #e5e5e5;
    color: ${({ theme }) => theme.themeColors.text};
    border-right: 1px solid ${({ theme }) => theme.themeColors.border};
    font-weight: inherit;
    text-align: center;
    min-width: 50px;
    position: sticky;
    left: -1px;
    z-index: 1;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #d0d0d0;
    }
  }

  tbody tr:hover {
    background: ${({ theme }) => theme.themeColors.lowContrastBorder};
  }

  tbody td:has(input:focus) {
    background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  }
`;
export const Cell = styled.td`
  position: relative;
  height: 25px; /* Fixed height: padding  content (16.8px) + 0.2px buffer */
  vertical-align: middle;
  padding: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  * {
    font-size: 14px;
    line-height: 1.2;
    font-family: inherit;
  }

  span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
  ${({ isEmpty, theme }) =>
    isEmpty &&
    `
    background: ${theme.themeColors.lowContrastBorder};
    font-style: italic;
    color: ${theme.themeColors.secondaryText};
  `}

  ${({ isEditable }) =>
    isEditable &&
    `
    cursor: text;
  `}

  ${({ isActive, theme }) =>
    isActive &&
    `
    border: 2px solid ${theme.themeColors.primaryCtaButton} !important;
    outline: none;
  `}

  input {
    display: block;
    width: 100%;
    border: none;
    background: transparent;
    font-size: 14px;
    padding: 0;
    margin: 0;
    outline: none;
    color: ${({ theme }) => theme.themeColors.text};
    font-family: inherit;
    line-height: 1.2;
    box-sizing: content-box;
    height: 16.8px; /* line-height 1.2 * font-size 14px */
    min-height: 16.8px;
    max-height: 16.8px;
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:focus {
      outline: none;
      box-shadow: none;
      border: none;
    }
  }
`;
export const CellInput = styled.input``;
export const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  color: ${({ theme }) => theme.themeColors.secondaryText};
  font-size: 14px;
`;
export const ErrorMessage = styled.div`
  padding: 16px;
  background: ${({ theme }) => theme.themeColors.error || '#ff0000'};
  color: ${({ theme }) => theme.themeColors.error || '#cc0000'};
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 14px;

  ul {
    margin: 8px 0 0 0;
    padding-left: 20px;
  }

  li {
    margin: 4px 0;
  }
`;

export const ResizeHandle = styled.div`
  position: absolute;
  top: 0;
  right: -4px;
  width: 8px;
  height: 100%;
  cursor: col-resize;
  z-index: 10;
  user-select: none;

  &:hover {
    background: ${({ theme }) => theme.themeColors.primaryCtaButton};
  }

  &:active {
    background: ${({ theme }) => theme.themeColors.primaryCtaButton};
  }
`;

export const HeaderCell = styled.th`
  position: relative;
`;

export const InsertColumnButton = styled.button`
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  padding: 0 0 3px 0;
  border: none;
  background: ${({ theme }) => theme.themeColors.primaryCtaButton};
  * {
    color: ${({ theme }) => theme.themeColors.buttonText};
  }
  color: ${({ theme }) => theme.themeColors.buttonText};
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s, background 0.2s;
  z-index: 5;

  &:hover {
    opacity: 0.8 !important;
    background: ${({ theme }) => theme.themeColors.primaryCtaButton};
  }

  &:active {
    opacity: 0.8 !important;
    background: ${({ theme }) => theme.themeColors.primaryCtaButton};
  }

  ${HeaderCell}:hover & {
    opacity: 0.6;
  }
`;
